module.exports = __webpack_public_path__ + "img/code-de-site-web.cd3a4c8f.jpg";